var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"text-center mt-2",attrs:{"cols":"12"}},[(_vm.product.active && _vm.product.stock > 0)?_c('v-btn',{staticClass:"ma-2",attrs:{"outlined":"","color":_vm.colorSet.norbitPrimary,"tile":""},domProps:{"innerHTML":_vm._s(_vm.basketText)},on:{"click":function($event){return _vm.addProductToBasket(1)}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }